import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { CartResult, GetCartApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";

type HandlerType = Handler<
    {
        shouldLoadFullCart?: boolean;
        replaceCart?: boolean;
        getPromotions?: boolean;
        getCartLines?: boolean;
        getCostCodes?: boolean;
    } & HasOnSuccess,
    {
        apiParameter: GetCartApiParameter;
        apiResult: CartResult;
        needFullCart: boolean;
    }
>;
export const CustomPopulateApiParameter: HandlerType = props => {
    const state = props.getState() as unknown as CustomApplicationState;
    const pageType = getCurrentPage(props.getState()).type;
    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        expand: ["validation"],
    };

    const isCheckoutReviewPage = state.SURData.isReviewSubmitPage.isReviewSubmitPage;

    if (props.needFullCart) {
        props.apiParameter.forceRecalculation = true;
        props.apiParameter.allowInvalidAddress = true;
        props.apiParameter.expand = [
            ...(props.apiParameter.expand || []),
            "cartLines",
            "restrictions",
            "tax",
            "paymentOptions",
            "costCodes",
        ];

        if (pageType === "CartPage") {
            const indexOfTax = props.apiParameter.expand.indexOf("tax");
            if (indexOfTax > -1) {
                props.apiParameter.expand.splice(indexOfTax, 1);
            }
          
        }

        if (isCheckoutReviewPage || pageType === "CheckoutReviewAndSubmitPage") {
            props.apiParameter.expand.push("shipping", "carriers");
        }
    }
    if (pageType === "CartPage") {
        props.apiParameter.expand?.push("hiddenproducts");
    }

    if (props.parameter.getCartLines) {
        props.apiParameter.expand?.push("cartLines");
    }

    if (props.parameter.getCostCodes) {
        props.apiParameter.expand?.push("costCodes");
    }
};
replaceInChain(chain, PopulateApiParameter, CustomPopulateApiParameter);
